var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos-not-indexed-and-enroll-Copy-6",
    transform: "translate(-706.000000, -325.000000)",
    fill: "#EB3C39",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-created-success",
    transform: "translate(546.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.478365,102.478365 L176.478365,93.4639423 L173.521635,93.4639423 L173.521635,102.478365 L176.478365,102.478365 Z M176.478365,108.536058 L176.478365,105.507212 L173.521635,105.507212 L173.521635,108.536058 L176.478365,108.536058 Z M175,86 C177.740398,86 180.276431,86.6850893 182.608173,88.0552885 C184.8678,89.3533719 186.646628,91.1322002 187.944712,93.3918269 C189.314911,95.7235694 190,98.2596017 190,101 C190,103.740398 189.314911,106.276431 187.944712,108.608173 C186.646628,110.8678 184.8678,112.646628 182.608173,113.944712 C180.276431,115.314911 177.740398,116 175,116 C172.259602,116 169.723569,115.314911 167.391827,113.944712 C165.1322,112.62259 163.353372,110.831742 162.055288,108.572115 C160.685089,106.240373 160,103.71636 160,101 C160,98.2836403 160.685089,95.759627 162.055288,93.4278846 C163.37741,91.1682579 165.168258,89.3774105 167.427885,88.0552885 C169.759627,86.6850893 172.28364,86 175,86 Z",
    id: "Error-icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.0c98d13f278d79124e5a936de2303108.svg";
export { ForwardRef as ReactComponent };